// src/components/ParticipantBox.js
import React from 'react';

const ParticipantBox = ({ count }) => {
  return (
    <div className="bg-white shadow-lg rounded-lg p-6 text-center relative z-10">
      <div className="text-gray-600 text-sm font-semibold uppercase">現在の演奏会参加人数</div>
      <div className="text-4xl font-bold text-blue-500 mt-2">{count}</div>
      <div className="text-gray-400 text-xs mt-1">人が参加予定</div>
      <div className="absolute top-0 right-0 p-2">
        <span className="bg-red-500 text-white text-xs rounded-full px-2 py-1">
          ライブ
        </span>
      </div>
    </div>
  );
};

export default ParticipantBox;
